import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { GenericAutocomplete } from '../../../components/others/GenericAutocomplete';

export const CreateGroup = ({ values, companies, errorInputs, t, handleInputChange }) => {

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                {t("group.createEditGroupsTitle")}
            </Typography>
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{xs:4, sm:4}}>
                    <GenericAutocomplete
                        options={companies}
                        value={values.id_company}
                        label={t('Company')}
                        name="id_company"
                        onChange={handleInputChange}
                    />
                </Grid>

                <Grid size={{xs:12, sm:4}}>
                    <TextField
                        fullWidth
                        label="name"
                        size="small"
                        name='name'
                        value={values.name}
                        onChange={handleInputChange}
                        error={Boolean(errorInputs.name?.isError)}
                        helperText={errorInputs.name?.messageError || ''}
                        required
                    />
                </Grid>

                <Grid size={{xs:12, sm:4}}>
                    <TextField
                        fullWidth
                        size="small"
                        name='prefix'
                        label="Prefix"
                        value={values.prefix}
                        onChange={handleInputChange}
                        error={Boolean(errorInputs.prefix?.isError)}
                        helperText={errorInputs.prefix?.messageError || ''}
                    />
                </Grid>

                <Grid size={{xs:12, sm:4}}>
                    <TextField
                        fullWidth
                        size="small"
                        name='status'
                        label="Status"
                        type='number'
                        value={values.status}
                        onChange={handleInputChange}
                        error={Boolean(errorInputs.status?.isError)}
                        helperText={errorInputs.status?.messageError || ''}
                    />
                </Grid>

                <Grid size={{xs:12, sm:4}}>
                    <TextField
                        fullWidth
                        size="small"
                        name='status_step'
                        label="Status Step"
                        type='number'
                        value={values.status_step}
                        onChange={handleInputChange}
                        error={Boolean(errorInputs.status_step?.isError)}
                        helperText={errorInputs.status_step?.messageError || ''}
                    />
                </Grid>

                <Grid size={{xs:12, sm:4}}>
                    <TextField
                        fullWidth
                        size="small"
                        name='path'
                        label="Path"
                        value={values.path}
                        onChange={handleInputChange}
                        error={Boolean(errorInputs.path?.isError)}
                        helperText={errorInputs.path?.messageError || ''}
                    />
                </Grid>

                <Grid size={{xs:12, sm:4}}>
                    <TextField
                        fullWidth
                        size="small"
                        name='cost_center'
                        label="Cost Center"
                        value={values.cost_center}
                        onChange={handleInputChange}
                        error={Boolean(errorInputs.cost_center?.isError)}
                        helperText={errorInputs.cost_center?.messageError || ''}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}